import { Switch, TableBody, TableCell, TableRow } from "@mui/material";
import { BaseTable } from "../../../components/table";
import { LoanChargesTablePropsType } from "../../../types/container.type";
import { formatAmountDisplay } from "../../../helpers/formatAmountDisplay";

export const LoanChargesTable: React.FC<LoanChargesTablePropsType> = ({ rows, loan, handleChargeUpdate }) => {
    const loanChargesTableHeaders = ["Charge Name", "Type", "Amount", "Apply? (Yes/No)"];

    return (
        <BaseTable headers={loanChargesTableHeaders}>
            <TableBody>
                {rows?.map((row, index) => {
                    return (
                        <TableRow key={index}>
                            <TableCell>{row?.name?.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{row?.type.split(' ').map((word: string) => word.charAt(0).toUpperCase() + word.slice(1)).join(' ')}</TableCell>
                            <TableCell>{formatAmountDisplay(row?.amount ?? 0)}</TableCell>
                            <TableCell>
                                <Switch
                                    checked={loan?.charges.includes(row?.id)}
                                    onChange={(e) => handleChargeUpdate(e, row?.id)}
                                    inputProps={{ 'aria-label': 'controlled' }}
                                />
                            </TableCell>
                        </TableRow>
                    )
                })}
            </TableBody>
        </BaseTable>
    )
}
